import React, { useContext } from 'react';
import Select from '../../../../components/shared/InputElements/Select';
import UserPrefsContext from '../../../../context/UserPrefs/UserPrefsContext';
import { FormattedMessage, useIntl } from 'react-intl';

const SelectCurrentRate = ({ rates }) => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);
  const currentRateTranslations = {
    'Regular Residential': intl.formatMessage({
      id: 'regularResidential',
      defaultMessage: 'Regular Residential',
    }),
  };

  return (
    <Select
      id="home-charging-advisor-current-rate-id"
      value={userPrefs.get('currentRateId')}
      handler={(e) => userPrefs.set({ currentRateId: e.target.value })}
      optionNames={rates.map(
        (rate) => currentRateTranslations?.[rate.title.join(' ')] || rate.id
      )}
      optionValues={rates.map((rate) => rate.id)}
      label={
        <FormattedMessage
          id="hcaCurrentElectricRate"
          defaultMessage="Current Rate"
          description="Current Rate"
        />
      }
    />
  );
};

export default SelectCurrentRate;
